import { initializeApp } from 'firebase/app';
import type { FirebaseApp } from 'firebase/app';
import { getAnalytics, isSupported, type Analytics } from 'firebase/analytics';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

if (!firebaseConfig.projectId) {
  console.error('[Firebase] Missing REACT_APP_FIREBASE_PROJECT_ID', {
    hasApiKey: Boolean(firebaseConfig.apiKey),
    hasAuthDomain: Boolean(firebaseConfig.authDomain),
    hasProjectId: Boolean(firebaseConfig.projectId),
    hasAppId: Boolean(firebaseConfig.appId),
  });
  throw new Error('Firebase is not configured: missing REACT_APP_FIREBASE_PROJECT_ID');
}

export const app: FirebaseApp = initializeApp(firebaseConfig);

export const db = getFirestore(app);

export let analytics: Analytics | undefined;

if (typeof window !== 'undefined') {
  isSupported()
    .then((supported) => {
      if (!supported) return;
      if (!firebaseConfig.measurementId) return;
      analytics = getAnalytics(app);
    })
    .catch(() => {
      // Ignore analytics init errors (e.g. blocked cookies, unsupported env)
        console.log("Error")
    });
}
